export enum GoalPeriod {
  CurrentAndFuture,
  CurrentOnly,
  LastYear,
  All,
  Custom
}
